import { Flex, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import Header from '../../components/Header';
import LoaderCircle from '../../components/LoaderCircle';
import TableData from '../Cases/components/TableData';
import useGetCaseProgressDetail from './hooks/useGetCaseProgressDetail';
import HeaderElement from './components/HeaderElement';

const CaseProgressDetail = () => {
  const { code } = useParams<{ code: string }>();
  const { detail, loading, error } = useGetCaseProgressDetail(code);

  return (
    <Flex flexDirection="column" minHeight="100vh">
      <Header title={`Pencapaian ${code ?? ''}`} />

      <Flex padding="10px 30px 30px" direction="column" gap="16px">
        {loading ? (
          <LoaderCircle />
        ) : error || !detail ? (
          <Text color="red.500">Gagal memuat data elemen {code}.</Text>
        ) : (
          <>
            <HeaderElement detail={detail} />
            <Text fontWeight="bold">Daftar Kasus ({detail.caseCount})</Text>
            {detail.cases.length === 0 ? (
              <Text color="gray.500" fontSize="14px">
                Belum ada kasus yang memenuhi elemen ini.
              </Text>
            ) : (
              <TableData caseList={detail.cases} />
            )}
          </>
        )}
      </Flex>
    </Flex>
  );
};

export default CaseProgressDetail;
